import { Component, Input, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { UserService } from '../../../services/user.service';
import { EmploymentService } from '../../../services/employment.service';
import {BehaviorSubject} from 'rxjs';
import { AddressService } from 'src/app/services/address.service';

@Component({
    selector: 'app-employment-fragment',
    templateUrl: './employment.component.html',
    styleUrls: ['./employment.component.scss'],
    standalone: false
})
export class EmploymentComponent implements OnInit {

  @Input() user;
  @Input() employment;

  public $edit = new BehaviorSubject(false);

  constructor(private navController: NavController,
              private employmentService: EmploymentService,
              private addressService: AddressService,
              private userService: UserService) {
    this.userService.$scopes.subscribe(
      scopes => {
        const ind = scopes.findIndex(s => s.name === 'manager');
        if (ind >= 0) {
          this.$edit.next(true);
        } else {
          this.$edit.next(false);
        }
      }
    );
  }

  ngOnInit() {
  }

  edit() {
    const employmentForms = [];
    const employmentForm = this.employmentService.createForm();
    this.employmentService.fillForm(this.employment, employmentForm);
    employmentForms.push(employmentForm);
    this.employmentService.$editing.next(employmentForms);

    const userForm = this.userService.createProfileForm();
    this.userService.fillProfileForm(userForm, this.user.profile);
    this.userService.$editing.next(userForm);

    const addressForm = this.addressService.createForm();
    if (this.user.address) {
      this.addressService.fillForm(this.user.address, addressForm);
    }
    this.addressService.$editing.next(addressForm);
    
    this.navController.navigateForward(['employment', 'edit', this.user.id]);
  }

  getManagees() {
    if (this.user?.manages?.length) {
      return this.user.manages.map(managee => managee.email).join(', ');
    } else {
      return 'No managees';
    }
  }
}
